import React from 'react'
import { Link } from 'react-router-dom'
import { Flex, Button, Box, Skeleton, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { keyframes } from 'styled-components'
import Balance from 'components/Balance'
import { usePriceATALIRABusd, usePricebabyBusd, usePriceBnbBusd, usePriceBTCBusd, usePricebuildBusd, usePriceBVCBusd, usePriceCakeBusd, usePriceETCBusd, usePriceETHBusd, usePriceEXZOBusd, usePriceHVIBusd, usePriceLameaBusd, usePriceLGCBusd, usePriceliraBusd, usePriceLTCBusd, usePriceskeletonBusd, usePricetripBusd } from 'state/farms/hooks'

const Container = styled.div`
height: 50px;
width: 100%;
overflow: hidden;
position: relative;
margin-bottom: 15px;
justify-content: space-between;
  ${({ theme }) => theme.mediaQueries.md} {
    border-radius: 8px;
    height: 50px;
    margin-bottom: 15px;
    overflow: hidden;
    width: 100%;
    position: relative;
    justify-content: space-between;
  }
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);

  ${({ theme }) => theme.mediaQueries.xs} {
    grid-gap: 16px;
    grid-template-columns: repeat(2, auto);
  }
  
  ${({ theme }) => theme.mediaQueries.sm} {
    grid-gap: 16px;
    grid-template-columns: repeat(2, auto);
  }

  ${({ theme }) => theme.mediaQueries.md} {
    grid-template-columns: repeat(4, auto);
    grid-gap: 32px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    grid-gap: 32px;
    grid-template-columns: repeat(4, auto);

  }  ${({ theme }) => theme.mediaQueries.xl} {
    grid-template-columns: repeat(4, auto);
    grid-gap: 32px;
  }
`

const ImageWrapper = styled.div`
flex: none;
margin: 0 auto;
margin-right: 5px;
${({ theme }) => theme.mediaQueries.md} {
  flex: none;
  margin: 0 auto;
  margin-right: 5px;

}
`
const floatingAnim = (x: string, y: string) => keyframes`
0% {transform: translate3d(0px, 0%, 0px);}
10% {transform: translate3d(0px, 0%, 0px);}
49.9999% {transform: translate3d(0px, 0%, 0px);}
50% {transform: translate3d(0px, -50px, 0px);}
99.9999% {transform: translate3d(0px, -50px, 0px);}
`
const floatingAnim2 = (x: string, y: string) => keyframes`
0% {transform: translate3d(0px, 0%, 0px);}
10% {transform: translate3d(0px, 0%, 0px);}
32.9999% {transform: translate3d(0px, 0%, 0px);}
33% {transform: translate3d(0px, -50px, 0px);}
43% {transform: translate3d(0px, -50px, 0px);}
65.99999% {transform: translate3d(0px, -50px, 0px);}
66% {transform: translate3d(0px, -100px, 0px);}
100% {transform: translate3d(0px, -100px, 0px);}
`

const Wrapper = styled(Box)`
position: relative;
animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
  animation-delay: 0s;
  ${({ theme }) => theme.mediaQueries.xs} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.md} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.xl} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    position: relative;
    animation: ${floatingAnim('3px', '15px')} 10s linear infinite;
      animation-delay: 0s;  
  }
`
const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`


interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
}

const TopTokenMovers: React.FC= () => {
  const { t } = useTranslation()
  const bnbprice0 = usePriceBnbBusd()
  const bnbprice = bnbprice0.toNumber()
  const lameaprice0 = usePriceLameaBusd()
  const lameaprice = lameaprice0.toNumber()
  const ehtprice0 = usePriceETHBusd()
  const ethprice = ehtprice0.toNumber()
  const lgcprice0 = usePriceLGCBusd()
  const lgcprice = lgcprice0.toNumber()
  const etcprice0 = usePriceETCBusd()
  const etcprice = etcprice0.toNumber()
  const ltcprice0 = usePriceLTCBusd()
  const ltcprice = ltcprice0.toNumber()
  const bvcprice0 = usePriceBVCBusd()
  const bvcprice = bvcprice0.toNumber()
  const buildprice0 = usePricebuildBusd()
  const buildprice = buildprice0.toNumber()
  const liraprice0 = usePriceliraBusd()
  const liraprice  = liraprice0.toNumber()
 const vizslaprice = usePriceCakeBusd()
 const vizslaprice0 = vizslaprice.toNumber()
 const exzoprice0 = usePriceEXZOBusd()
 const exzoprice = exzoprice0.toNumber()
 const ataliraprice0 = usePriceATALIRABusd()
 const ataliraprice = ataliraprice0.toNumber()
 const tripprice0 = usePricetripBusd()
 const tripprice = tripprice0.toNumber()
 const skeletonprice0 = usePriceskeletonBusd()
 const skeletonprice = skeletonprice0.toNumber()
 const babyprice0 = usePricebabyBusd()
 const babyprice = babyprice0.toNumber()
 const btc0 = usePriceBTCBusd()
 const btc = btc0.toNumber()

  return (
    <Container>
                <Flex justifyContent="center" alignItems="center">
                <Grid>
                <Wrapper>

    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c">
      <ImageWrapper>
        <img src="/images/wallet/23.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('BTC')}
        </ButtonText>
        {btc ? (
          <Balance fontSize="15px" prefix="$" decimals={2} value={btc} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
        </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0xaa44051bdd76E251aab66dbbE82A97343B4D7DA3">
      <ImageWrapper>
        <img src="/images/wallet/5.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('LAMEA')}
        </ButtonText>
        {lameaprice ? (
          <Balance fontSize="15px" prefix="$" decimals={5} value={lameaprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}    
        </Flex >
      </Button>
      </Flex>
      </Wrapper>
    

      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c">
      <ImageWrapper>
        <img src="/images/wallet/1.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('BNB')}
        </ButtonText>
        {bnbprice ? (
          <Balance fontSize="15px" prefix="$" decimals={2} value={bnbprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
        </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x3496212eC43Cc49F5151ec4405efD4975e036f89">
      <ImageWrapper>
        <img src="/images/wallet/6.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('LGC')}
        </ButtonText>
        {lgcprice ? (
          <Balance fontSize="15px" prefix="$" decimals={4} value={lgcprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
        </Flex >
      </Button>
      </Flex>
      </Wrapper>


      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x2170Ed0880ac9A755fd29B2688956BD959F933F8">
      <ImageWrapper>
        <img src="/images/wallet/19.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('ETH')}
        </ButtonText>
        {ethprice ? (
          <Balance fontSize="15px" prefix="$" decimals={2} value={ethprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}
        </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x2dEA12c4f08074032a9997F0a199b04aF0fC0392">
      <ImageWrapper>
        <img src="/images/wallet/7.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('BVC')}
        </ButtonText>
        {bvcprice ? (
          <Balance fontSize="15px" prefix="$" decimals={5} value={bvcprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}     
       </Flex >
      </Button>
      </Flex>
      </Wrapper>

      <Wrapper>
    <Flex flexDirection="column" alignItems="center" >
    <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x4338665CBB7B2485A8855A139b75D5e34AB0DB94">
      <ImageWrapper>
        <img src="/images/wallet/18.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('LTC')}
        </ButtonText>
        {ltcprice ? (
          <Balance fontSize="15px" prefix="$" decimals={2} value={ltcprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}    
        </Flex >
      </Button>
      <Button as={Link} width={120}  height={50} variant="secondary" to="/swap?outputCurrency=0x15a0Ff684918B20487f2a68d6816e694BB05E471">
      <ImageWrapper>
        <img src="/images/wallet/13.png" alt="ifo bunny" width="27px" height="27px"/>
      </ImageWrapper>
      <Flex flexDirection="column" alignItems="left" >
      <ButtonText color="primary" bold fontSize="12px">
          {t('TRIP')}
        </ButtonText>
        {tripprice ? (
          <Balance fontSize="15px" prefix="$" decimals={5} value={tripprice} />
        ) : (
          <Skeleton width={60} height={16} />
        )}     
       </Flex >
      </Button>
      </Flex>
      </Wrapper>

      </Grid>
      </Flex>
      </Container>
  )
}

export default TopTokenMovers
